import React, { useState } from 'react';

import { ReactComponent as CrossSVG } from 'modules/theme/icons/general/cross.svg';

import styles from './styles.module.scss';

type PeopleCertPopupProps = {
  onClose?: () => void;
};

const PeopleCertPopup: React.FunctionComponent<PeopleCertPopupProps> = ({
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.popupContainer}>
      <div className={styles.popup}>
        <div className={styles.popupHeader}>
          <div className={styles.logoContainer}>
            <img
              src="/pc-logo-25th-ann-07022025.svg"
              alt="PeopleCert"
              className={styles.logoText}
            />
          </div>
          <button
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Close popup"
            title="Close popup"
            type="button"
          >
            <CrossSVG />
          </button>
        </div>
        <div className={styles.popupBody}>
          <p className={`${styles.text} ${styles.boldText}`}>
            MyAxelos will soon be discontinued, and all services have moved to
            peoplecert.org, using your existing credentials.
          </p>
          <ul className={styles.bulletList}>
            <li className={styles.text}>
              To access ACP Programme resources, log in{' '}
              <a
                href="https://login.peoplecert.org/?lg=1"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                here
              </a>
              .
            </li>
            <li className={styles.text}>
              To access PeopleCert Membership for information on certifications,
              exams, and learning content, log in{' '}
              <a
                href="https://www.peoplecert.org/login"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                here
              </a>
              .
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PeopleCertPopup;
